module.exports = __webpack_public_path__ + "img/jess.e70b3110.jpg";